import { render, staticRenderFns } from "./EditDpaAccountComponent.vue?vue&type=template&id=303dfdaf&"
import script from "./EditDpaAccountComponent.vue?vue&type=script&lang=js&"
export * from "./EditDpaAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports